import {Injectable} from '@angular/core';
import {Observable, Subject, Subscription} from 'rxjs';

/**
 * An event encapsulates a Subject a derived Observable and an identifying title string.
 */
export interface Event {
  title: string;
  subject: Subject<any>;
  observable: Observable<any>;
}

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  private events: Event[] = [];

  /**
   * Fires a named event, passing along optional data.
   *
   * @param title unique title for the event
   * @param data params to pass to a callback
   */
  publish(title: string, data?: any) {
    let associatedEvent = this.events.find(event => event.title === title);
    if (!associatedEvent) {
      associatedEvent = this.createEvent(title);
    }
    associatedEvent.subject.next(data);
  }

  /**
   * Subscribes to a named event by providing a callback function.
   * Returns a Subscription which can be used to unsubscribe from the event.
   * @param title unique title for the event
   * @param callback callback function to be executed when given event is published
   */
  subscribe(title: string, callback: (data?: any) => void): Subscription {
    let associatedEvent = this.events.find(event => event.title === title);
    if (!associatedEvent) {
      associatedEvent = this.createEvent(title);
    }
    return associatedEvent.observable.subscribe(callback);
  }

  /**
   * Creates a new event
   * @param title unique title for the event
   */
  private createEvent(title: string): Event {
    const subject = new Subject();
    const observable = subject.asObservable();
    const count = this.events.push({title, subject, observable});
    return this.events[count - 1];
  }
}
